export default __webpack_public_path__ + "static/webRotator/svg/ed9d22d5be76f4a2b69c03bd1c5b7262.svg";